var _effectorFileName = "/src/shared/components/article/article.tsx";
import React, { JSX } from 'react';
import { GradientBg } from '@/shared/components/animation/gradient-background';
import { cn } from '@/shared/lib/cn';
interface ArticleProps {
  children: React.ReactNode;
  tag?: 'article' | 'main';
  withContainer?: boolean;
  className?: string;
  id?: string;
  withGradientBg?: boolean;
}
export const Article = (props: ArticleProps) => {
  const {
    children,
    tag = 'article',
    withContainer = true,
    className,
    id,
    withGradientBg = false
  } = props;
  const ComponentTag = tag as keyof JSX.IntrinsicElements;
  return <div className={tag === 'main' ? 'mt-[69px] overflow-hidden' : ''}>
      <ComponentTag id={id} className={cn('py-6 sm:py-16', {
      container: withContainer,
      'relative flex min-h-[calc(100vh-70px)] flex-col place-content-center 2xl:min-h-[70vh] 2xl:py-20': tag === 'main'
    }, className)}>
        <>
          <div className="z-10">{children}</div>
          {tag === 'main' && <GradientBg className={cn('z-0', {
          'sm:hidden': !withGradientBg
        })} type="circle" origin="center" size={400} />}
        </>
      </ComponentTag>
    </div>;
};